/** True when SAN is check. Checkmate uses `#` and is excluded. */
export function moveGivesCheck(move) {
  const san = typeof move === 'string' ? move : move?.san;
  return typeof san === 'string' && san.endsWith('+');
}

/** True when SAN records a capture (including en passant). */
export function moveIsCapture(move) {
  const san = typeof move === 'string' ? move : move?.san;
  return typeof san === 'string' && san.includes('x');
}

/**
 * Decide whether a newly adopted game should show the check cue.
 * `previousPly === undefined` is the first snapshot (hydrate): record the ply, stay quiet.
 * Later cues fire only when a new ply leaves the king in check and the game is still playing.
 */
export function checkCueForUpdate(previousPly, game) {
  const moves = game?.moves;
  const last = moves?.length ? moves[moves.length - 1] : null;
  const ply = last?.ply ?? 0;

  if (previousPly === undefined || previousPly === null || !game) {
    return { announce: false, clear: false, ply };
  }

  if (ply === previousPly) {
    return {
      announce: false,
      clear: game.status !== 'playing',
      ply
    };
  }

  const checking = game.status === 'playing' && moveGivesCheck(last);
  return { announce: checking, clear: !checking, ply };
}
